import { SummarizeConversationMessage } from '@@types/models/CreateReport';

import { SingleMessage } from '@domains/new-conversation/atoms/SingleMessage/SingleMessage';
import {
    SummaryEditIcon,
    UserMessage,
    UserResponseWrapper,
} from '@domains/new-conversation/molecules/SummaryUserResponseMessage/SummaryUserResponseMessage.styled';
import { EditSummaryForm } from '@domains/new-conversation/organisms/EditSummaryForm/EditSummaryForm';

interface SummaryUserResponseMessageProps {
    currentEdit: string;
    message: SummarizeConversationMessage;
    setCurrentEdit: (edit: string) => void;
}

export const SummaryUserResponseMessage = ({
    currentEdit,
    message,
    setCurrentEdit,
}: SummaryUserResponseMessageProps) => {
    const isEditable = message.canEdit;
    const isEditActive = currentEdit === `active-${message.uuid}`;

    return (
        <UserResponseWrapper>
            <UserMessage>
                {!isEditActive &&
                    (isEditable ? (
                        <SummaryEditIcon
                            iconProps={{
                                icon: 'SvgEdit24',
                                size: 24,
                                themeColors: {
                                    default: { 'color-1': 'main.tertiary' },
                                },
                            }}
                            isEditable={isEditable}
                            onClick={() => {
                                setCurrentEdit(`active-${message.uuid}`);
                            }}
                            testId="oXaqZ3D"
                        />
                    ) : (
                        <SummaryEditIcon
                            iconProps={{
                                icon: 'SvgEnd',
                                size: 16,
                                themeColors: {
                                    default: { 'color-1': 'neutral.darkGrey' },
                                },
                            }}
                            testId="uccj-cY"
                        />
                    ))}
                {isEditActive ? (
                    <EditSummaryForm
                        message={message}
                        onCallback={() => setCurrentEdit('')}
                    />
                ) : (
                    <SingleMessage
                        isUserMessage
                        onClick={() =>
                            isEditable &&
                            setCurrentEdit(`active-${message.uuid}`)
                        }
                    >
                        {message.text}
                    </SingleMessage>
                )}
            </UserMessage>
        </UserResponseWrapper>
    );
};
